import type {Theme} from '../theme';
import {createBaseThemeVariation} from './base';

export const KinderzimmerUKTheme: Theme = createBaseThemeVariation({
    name: 'kinderzimmeruk',
    brandColor: 'hsla(160, 59%, 16%, 1)',
    primaryColors: {
        p50: 'hsla(160, 59%, 98%, 1)',
        p75: 'hsla(160, 59%, 97%, 1)',
        p100: 'hsla(160, 59%, 96%, 1)',
        p200: 'hsla(160, 59%, 90%, 1)',
        p300: 'hsla(160, 59%, 70%, 1)',
        p400: 'hsla(160, 59%, 16%, 1)',
        p500: 'hsla(160, 59%, 10%, 1)',
    },
});
